module.exports = __webpack_public_path__ + "img/img1zhTc.a09641f1.png";